import React, { Component, useEffect, useState } from 'react';
const LocationMap = (props) => {
  const { branch } = props;
  const { location } = branch
  const [ map, setMap ] = useState(null);
  useEffect(() => {
    const lat = branch.location.lat
    const lng = branch.location.long
    const zoom = 14
    const map = new google.maps.Map(document.getElementById('map-place-3'), {
      center: { lat, lng },
      zoom,
      mapTypeId: 'roadmap',
      mapId: '5614c50fd8a6e35e13c4142f',
    })
    setMap(map)

    makeMarker(map)
  },[branch])



  const makeMarker = async (map) => {
    const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary("marker");
    const pinBorder = new PinElement({
      borderColor: '#fff',
      background: '#F47A20',
      glyphColor: 'white',
      scale: 1.3
    });

    var marker = new AdvancedMarkerElement({
      position: { lat: location.lat, lng: location.long },
      title: location.title,
      map: map,
      gmpClickable: true,
      content: pinBorder.element
    });
  }

  return (
    <div className="ml-4">
    <div id="map-place-3" style={{
      height: '100%',
      minHeight: '400px'
    }}>
    </div>
    </div>
  )
}

export default LocationMap